import {
  BaseObjectDTO, TenderDTO, TenderLotV2DTO
} from '../../../api/plyca-dtos';
import { ProcurementProjectLotDTO, ValidationResultDTO } from '../../../api/plyca-dtos-v2';

export interface WorkTenderClassificationDTO extends BaseObjectDTO<string> {
  identifier: string;
  tenderClassification: TenderClassificationDTO;
  // context?: ObjectContextDTO;
}

export interface TenderClassificationDTO extends BaseObjectDTO<string> {
  // context?: ObjectContextDTO;
  tenderLotClassifications: Array<TenderLotClassificationDTO>;
  sortedTenderLotClassifications: Array<TenderLotClassificationDTO>;
  sortedTenderLotClassificationsMap: Map<number, Array<TenderLotClassificationDTO>>;
  validationResult: ValidationResultDTO;
}

export interface TenderLotClassificationDTO {
  procurementProjectLot: ProcurementProjectLotDTO; // Datos sobre el lote ofertado
  tender: TenderDTO;
  tenderLot: TenderLotV2DTO;
  tenderLotClassificationDataDisplay: TenderLotClassificationDataDisplayDTO;
}

export interface TenderLotClassificationDataDisplayDTO {
  tiebreak: boolean; // desempatar;
  tiebreakPosition: number; // posicionPorDesempatar;
  recordedAwardProposal: boolean;// propuestAdjDatoBBDD
  tiedPosition: boolean; // posicionEmpate;
}

export enum TenderClassificationType {
  CONSULTAR = 'CONSULTAR',
  CLASIFICAR = 'CLASIFICAR',
  DESEMPATAR = 'DESEMPATAR',
  PROPUESTA_ADJUDICACION = 'PROPUESTA_ADJUDICACION'
}